var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
import "reflect-metadata";
import "es6-shim";

// src/api-service.ts
import axios from "axios";
import qs from "qs";

// src/abstract-api.request.ts
var ApiRequestMethod = /* @__PURE__ */ function(ApiRequestMethod2) {
  ApiRequestMethod2["GET"] = "GET";
  ApiRequestMethod2["POST"] = "POST";
  ApiRequestMethod2["DELETE"] = "DELETE";
  ApiRequestMethod2["PUT"] = "PUT";
  return ApiRequestMethod2;
}({});
var _AbstractApiRequest = class _AbstractApiRequest {
  constructor() {
    /**
    * JWT token required
    */
    __publicField(this, "isPrivate", false);
    /**
    * Available only from client side
    */
    __publicField(this, "clientOnly", false);
  }
  // readonly responseBody: D; // never used but needed for define the response data type on the fly
  /**
  * @example
  * For url 'host.com/api/some_path'.
  * getApiUrl() {
  *     return 'host.com/api';
  *   }
  *
  * If getApiUrl is not override then getApiUrl is taken from configAdapter. See interface IApiServiceAdapter
  */
  getApiUrl() {
    return null;
  }
  /**
  * @example
  * For url '/some_path/:userId/user';
  * getUrlParams() {
  *   return { userId: '123' }
  * }
  */
  getUrlParams() {
    return {};
  }
  /**
  * @example
  * For url '/some_path/?parameter=1';
  * getParams() {
  *   return { parameter: 1 }
  * }
  */
  getQueryParams() {
    return null;
  }
  getBody() {
    return null;
  }
  getHeaders() {
    return null;
  }
  /* Data mapper method */
  prepareResponse(data) {
    return data;
  }
};
__name(_AbstractApiRequest, "AbstractApiRequest");
var AbstractApiRequest = _AbstractApiRequest;

// src/api-service.ts
var _ApiService = class _ApiService {
  constructor(user, errorHandler) {
    __publicField(this, "user");
    __publicField(this, "errorHandler");
    this.user = user;
    this.errorHandler = errorHandler;
  }
  setUser(user) {
    this.user = user;
  }
  setErrorHandler(errorHandler) {
    this.errorHandler = errorHandler;
  }
  async send(request, withErrorHandler = true) {
    let uri = request.url;
    let uriPrefix = "";
    for (const key in request.getUrlParams()) {
      if (Object.prototype.hasOwnProperty.call(request.getUrlParams(), key)) {
        uri = uri.replace(`:${key}`, request.getUrlParams()[key].toString());
      }
    }
    if (typeof window === "undefined") {
      if (request.clientOnly) {
        throw new Error("This endpoint available only on client side");
      }
      uriPrefix = "http://balancer";
    }
    const { data } = await this.sendRequest(`${uriPrefix}${uri}`, request, withErrorHandler);
    return Promise.resolve(request.prepareResponse(data));
  }
  async sendRequest(url, request, withErrorHandler = true) {
    const headers = {};
    if (request.isPrivate && this.user?.token?.length > 0) {
      headers["Authorization"] = "Bearer " + this.user.token;
    }
    const queryParams = {
      params: request.getQueryParams(),
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {
            arrayFormat: "brackets",
            encoder: (str) => {
              return encodeURIComponent(str);
            }
          });
        }
      }
    };
    try {
      switch (request.method) {
        case ApiRequestMethod.GET:
          return await axios.get(url, {
            headers,
            ...queryParams
          });
        case ApiRequestMethod.POST:
          return await axios.post(url, request.getBody(), {
            headers,
            ...queryParams
          });
        case ApiRequestMethod.PUT:
          return await axios.put(url, request.getBody(), {
            headers
          });
        default:
          throw new Error(`Method doesn't implemented`);
      }
    } catch (error) {
      if (this.errorHandler && withErrorHandler) {
        this.errorHandler(error);
        throw error;
      }
      console.log("Request error");
      console.log(url);
      console.log(request.getUrlParams());
      console.log(request.getQueryParams());
      console.log(request.getBody());
      if (axios.isAxiosError(error)) {
        const aerror = error;
        console.log(aerror?.response?.data);
      }
      throw error;
    }
  }
};
__name(_ApiService, "ApiService");
var ApiService = _ApiService;

// src/request/get-blog-item.request.ts
var _GetBlogItemRequest = class _GetBlogItemRequest extends AbstractApiRequest {
  constructor(slug, locale) {
    super();
    __publicField(this, "slug");
    __publicField(this, "locale");
    __publicField(this, "method", ApiRequestMethod.GET);
    this.slug = slug, this.locale = locale;
  }
  getUrlParams() {
    return {
      slug: this.slug,
      locale: this.locale
    };
  }
  get url() {
    return `/cms/api/blog-items?filters[$and][0][slug][$eq]=${this.slug}&locale=${this.locale}&populate[localizations][fields][0]=locale&populate[localizations][fields][1]=slug`;
  }
};
__name(_GetBlogItemRequest, "GetBlogItemRequest");
var GetBlogItemRequest = _GetBlogItemRequest;

// src/request/get-blog-items.request.ts
var _GetBlogItemsQueryDto = class _GetBlogItemsQueryDto {
  constructor() {
    __publicField(this, "offset", 0);
  }
};
__name(_GetBlogItemsQueryDto, "GetBlogItemsQueryDto");
var GetBlogItemsQueryDto = _GetBlogItemsQueryDto;
var _GetBlogItemsRequest = class _GetBlogItemsRequest extends AbstractApiRequest {
  constructor(queryDto) {
    super();
    __publicField(this, "queryDto");
    __publicField(this, "method", ApiRequestMethod.GET);
    this.queryDto = queryDto;
  }
  get url() {
    return `/cms/api/blog-items`;
  }
  getQueryParams() {
    return this.queryDto;
  }
};
__name(_GetBlogItemsRequest, "GetBlogItemsRequest");
var GetBlogItemsRequest = _GetBlogItemsRequest;

// src/request/get-deposit.request.ts
var _GetDepositRequest = class _GetDepositRequest extends AbstractApiRequest {
  constructor(productIndex, language) {
    super();
    __publicField(this, "productIndex");
    __publicField(this, "language");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/deposits/:productIndex");
    this.productIndex = productIndex, this.language = language;
  }
  getUrlParams() {
    return {
      productIndex: this.productIndex
    };
  }
  getQueryParams() {
    return {
      language: this.language,
      is_test: true
    };
  }
};
__name(_GetDepositRequest, "GetDepositRequest");
var GetDepositRequest = _GetDepositRequest;

// src/request/get-deposits.request.ts
var _GetDepositsRequest = class _GetDepositsRequest extends AbstractApiRequest {
  constructor(queryDto) {
    super();
    __publicField(this, "queryDto");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/deposits");
    this.queryDto = queryDto;
  }
  getQueryParams() {
    return this.queryDto;
  }
};
__name(_GetDepositsRequest, "GetDepositsRequest");
var GetDepositsRequest = _GetDepositsRequest;

// src/request/deposit/get-deposits-statistics.request.ts
var _GetDepositsStatisticsRequest = class _GetDepositsStatisticsRequest extends AbstractApiRequest {
  constructor(dto) {
    super();
    __publicField(this, "dto");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/deposits/statistics");
    this.dto = dto;
  }
  getQueryParams() {
    return this.dto;
  }
};
__name(_GetDepositsStatisticsRequest, "GetDepositsStatisticsRequest");
var GetDepositsStatisticsRequest = _GetDepositsStatisticsRequest;

// src/request/get-filtered-blog-items.request.ts
var _GetFilteredBlogItemsRequest = class _GetFilteredBlogItemsRequest extends AbstractApiRequest {
  constructor(params) {
    super();
    __publicField(this, "params");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", `/cms/api/blog-items`);
    this.params = params;
  }
  getQueryParams() {
    const obj = {};
    if (this.params.filter?.field) {
      obj.filters = {
        [this.params.filter.field]: {
          [this.params.filter.operator]: this.params.filter.value
        }
      };
    }
    if (this.params.filter?.slug) {
      obj.filters.slug = {
        $ne: this.params.filter.slug
      };
    }
    if (this.params.pagination?.start) {
      obj.pagination = {
        start: this.params.pagination.start
      };
    }
    if (this.params.pagination?.limit) {
      obj.pagination = {
        limit: this.params.pagination.limit
      };
    }
    if (this.params.sort) {
      obj.sort = `${this.params.sort.field}:${this.params.sort.order}`;
    }
    if (this.params.locale) {
      obj.locale = this.params.locale;
    }
    if (this.params.field) {
      obj.fields = this.params.field;
    }
    return obj;
  }
};
__name(_GetFilteredBlogItemsRequest, "GetFilteredBlogItemsRequest");
var GetFilteredBlogItemsRequest = _GetFilteredBlogItemsRequest;

// src/request/get-page.request.ts
var _GetSlugPageRequest = class _GetSlugPageRequest extends AbstractApiRequest {
  constructor(slug, locale) {
    super();
    __publicField(this, "slug");
    __publicField(this, "locale");
    __publicField(this, "method", ApiRequestMethod.GET);
    this.slug = slug, this.locale = locale;
  }
  getUrlParams() {
    return {
      slug: this.slug,
      locale: this.locale
    };
  }
  get url() {
    return `/cms/api/pages?filters[link][$eq]=${this.slug}&locale=${this.locale}&populate=deep`;
  }
};
__name(_GetSlugPageRequest, "GetSlugPageRequest");
var GetSlugPageRequest = _GetSlugPageRequest;

// src/request/get-landing-page.request.ts
var _GetSlugLandingPageRequest = class _GetSlugLandingPageRequest extends AbstractApiRequest {
  constructor(slug, locale) {
    super();
    __publicField(this, "slug");
    __publicField(this, "locale");
    __publicField(this, "method", ApiRequestMethod.GET);
    this.slug = slug, this.locale = locale;
  }
  getUrlParams() {
    return {
      slug: this.slug,
      locale: this.locale
    };
  }
  get url() {
    return `/cms/api/landing-pages?filters[link][$eq]=${this.slug}&locale=${this.locale}&populate[localizations][fields][0]=link&populate[localizations][fields][1]=locale`;
  }
};
__name(_GetSlugLandingPageRequest, "GetSlugLandingPageRequest");
var GetSlugLandingPageRequest = _GetSlugLandingPageRequest;

// src/request/auth/post-login.request.ts
var PostLoginRequestError = /* @__PURE__ */ function(PostLoginRequestError2) {
  PostLoginRequestError2["VERIFICATION_MESSAGE_HAS_SENT"] = "verification-message-has-sent";
  PostLoginRequestError2["VERIFICATION_CODE_IS_INVALID"] = "verification-code-is-invalid";
  PostLoginRequestError2["PHONE_NUMBER_COUNTRY_NOT_FOUND"] = "phone-number-country-not-found";
  PostLoginRequestError2["PHONE_NUMBER_IS_INVALID"] = "phone-number-is-invalid";
  return PostLoginRequestError2;
}({});
var _PostLoginRequest = class _PostLoginRequest extends AbstractApiRequest {
  constructor(loginDTO) {
    super();
    __publicField(this, "loginDTO");
    __publicField(this, "method", ApiRequestMethod.POST);
    __publicField(this, "url", "/api/auth/login");
    this.loginDTO = loginDTO;
  }
  getBody() {
    return this.loginDTO;
  }
};
__name(_PostLoginRequest, "PostLoginRequest");
var PostLoginRequest = _PostLoginRequest;

// src/request/compliance/verification/get-compliance-verification-status.request.ts
var _GetComplianceVerificationStatusRequest = class _GetComplianceVerificationStatusRequest extends AbstractApiRequest {
  constructor() {
    super(...arguments);
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/compliance/verification/status");
    __publicField(this, "isPrivate", true);
  }
};
__name(_GetComplianceVerificationStatusRequest, "GetComplianceVerificationStatusRequest");
var GetComplianceVerificationStatusRequest = _GetComplianceVerificationStatusRequest;

// src/request/compliance/verification/get-compliance-verification.request.ts
var _GetComplianceVerificationRequest = class _GetComplianceVerificationRequest extends AbstractApiRequest {
  constructor(uuid) {
    super();
    __publicField(this, "uuid");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/compliance/verification/:uuid");
    __publicField(this, "isPrivate", true);
    this.uuid = uuid;
  }
  getUrlParams() {
    return {
      uuid: this.uuid
    };
  }
};
__name(_GetComplianceVerificationRequest, "GetComplianceVerificationRequest");
var GetComplianceVerificationRequest = _GetComplianceVerificationRequest;

// src/request/compliance/verification/post-compliance-verification-action.request.ts
var _PostComplianceVerificationActionRequest = class _PostComplianceVerificationActionRequest extends AbstractApiRequest {
  constructor(uuid) {
    super();
    __publicField(this, "uuid");
    __publicField(this, "method", ApiRequestMethod.POST);
    __publicField(this, "url", "/api/compliance/verification/:uuid/action");
    __publicField(this, "isPrivate", true);
    this.uuid = uuid;
  }
  getUrlParams() {
    return {
      uuid: this.uuid
    };
  }
};
__name(_PostComplianceVerificationActionRequest, "PostComplianceVerificationActionRequest");
var PostComplianceVerificationActionRequest = _PostComplianceVerificationActionRequest;

// src/request/compliance/verification/post-compliance-verification-verify.request.ts
var _PostComplianceVerificationVerifyRequest = class _PostComplianceVerificationVerifyRequest extends AbstractApiRequest {
  constructor(uuid, dto) {
    super();
    __publicField(this, "uuid");
    __publicField(this, "dto");
    __publicField(this, "method", ApiRequestMethod.POST);
    __publicField(this, "url", "/api/compliance/verification/:uuid/verify");
    __publicField(this, "isPrivate", true);
    this.uuid = uuid, this.dto = dto;
  }
  getBody() {
    return this.dto;
  }
  getUrlParams() {
    return {
      uuid: this.uuid
    };
  }
};
__name(_PostComplianceVerificationVerifyRequest, "PostComplianceVerificationVerifyRequest");
var PostComplianceVerificationVerifyRequest = _PostComplianceVerificationVerifyRequest;

// src/request/user/profile/get-user-profile.request.ts
var _GetUserProfileRequest = class _GetUserProfileRequest extends AbstractApiRequest {
  constructor() {
    super(...arguments);
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/user/profile");
    __publicField(this, "isPrivate", true);
  }
};
__name(_GetUserProfileRequest, "GetUserProfileRequest");
var GetUserProfileRequest = _GetUserProfileRequest;

// src/request/user/profile/put-user-profile.request.ts
var _PutUserProfileRequest = class _PutUserProfileRequest extends AbstractApiRequest {
  constructor(putProfileDto) {
    super();
    __publicField(this, "putProfileDto");
    __publicField(this, "method", ApiRequestMethod.PUT);
    __publicField(this, "url", "/api/user/profile");
    __publicField(this, "isPrivate", true);
    this.putProfileDto = putProfileDto;
  }
  getBody() {
    return this.putProfileDto;
  }
};
__name(_PutUserProfileRequest, "PutUserProfileRequest");
var PutUserProfileRequest = _PutUserProfileRequest;

// src/request/user/profile/get-user-profile-attributes.request.ts
var _GetUserProfileAttributesRequest = class _GetUserProfileAttributesRequest extends AbstractApiRequest {
  constructor() {
    super(...arguments);
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/user/profile/attributes");
    __publicField(this, "isPrivate", true);
  }
};
__name(_GetUserProfileAttributesRequest, "GetUserProfileAttributesRequest");
var GetUserProfileAttributesRequest = _GetUserProfileAttributesRequest;

// src/request/user/profile/put-user-profile-attributes.request.ts
var _PutUserProfileAttributesRequest = class _PutUserProfileAttributesRequest extends AbstractApiRequest {
  constructor(attributesDto) {
    super();
    __publicField(this, "attributesDto");
    __publicField(this, "method", ApiRequestMethod.PUT);
    __publicField(this, "url", "/api/user/profile/attributes");
    __publicField(this, "isPrivate", true);
    this.attributesDto = attributesDto;
  }
  getBody() {
    return this.attributesDto;
  }
};
__name(_PutUserProfileAttributesRequest, "PutUserProfileAttributesRequest");
var PutUserProfileAttributesRequest = _PutUserProfileAttributesRequest;

// src/request/public/reference-books/get-countries.request.ts
var _GetCountriesRequest = class _GetCountriesRequest extends AbstractApiRequest {
  constructor() {
    super(...arguments);
    __publicField(this, "method", ApiRequestMethod.GET);
  }
  get url() {
    return `/api/public/reference-books/countries`;
  }
};
__name(_GetCountriesRequest, "GetCountriesRequest");
var GetCountriesRequest = _GetCountriesRequest;

// src/request/auth/post-verify.request.ts
var _PostVerifyRequest = class _PostVerifyRequest extends AbstractApiRequest {
  constructor(verifyDto) {
    super();
    __publicField(this, "verifyDto");
    __publicField(this, "method", ApiRequestMethod.POST);
    __publicField(this, "url", "/api/auth/verify");
    this.verifyDto = verifyDto;
  }
  getBody() {
    return this.verifyDto;
  }
};
__name(_PostVerifyRequest, "PostVerifyRequest");
var PostVerifyRequest = _PostVerifyRequest;

// src/request/get-footer-pages.request.ts
var _GetFooterPagesRequest = class _GetFooterPagesRequest extends AbstractApiRequest {
  constructor(locale) {
    super();
    __publicField(this, "locale");
    __publicField(this, "method", ApiRequestMethod.GET);
    this.locale = locale;
  }
  getUrlParams() {
    return {
      locale: this.locale
    };
  }
  get url() {
    return `/cms/api/pages?locale=${this.locale}&fields[0]=title&fields[1]=link&populate=positionOnTheSite&filters[positionOnTheSite][position][$notNull]=*`;
  }
};
__name(_GetFooterPagesRequest, "GetFooterPagesRequest");
var GetFooterPagesRequest = _GetFooterPagesRequest;

// src/request/application/post-application-confirm.request.ts
var _PostApplicationConfirmRequest = class _PostApplicationConfirmRequest extends AbstractApiRequest {
  constructor(applicationUuid, dto) {
    super();
    __publicField(this, "applicationUuid");
    __publicField(this, "dto");
    __publicField(this, "method", ApiRequestMethod.POST);
    __publicField(this, "url", "/api/application/:application_uuid/confirm");
    __publicField(this, "isPrivate", true);
    this.applicationUuid = applicationUuid, this.dto = dto;
  }
  getBody() {
    return this.dto;
  }
  getUrlParams() {
    return {
      application_uuid: this.applicationUuid
    };
  }
};
__name(_PostApplicationConfirmRequest, "PostApplicationConfirmRequest");
var PostApplicationConfirmRequest = _PostApplicationConfirmRequest;

// src/request/application/post-application-apply.request.ts
var _PostApplicationApplyRequest = class _PostApplicationApplyRequest extends AbstractApiRequest {
  constructor(dto) {
    super();
    __publicField(this, "dto");
    __publicField(this, "method", ApiRequestMethod.POST);
    __publicField(this, "url", "/api/application/apply");
    __publicField(this, "isPrivate", true);
    this.dto = dto;
  }
  getBody() {
    return this.dto;
  }
};
__name(_PostApplicationApplyRequest, "PostApplicationApplyRequest");
var PostApplicationApplyRequest = _PostApplicationApplyRequest;

// src/request/application/get-application.request.ts
var _GetApplicationRequest = class _GetApplicationRequest extends AbstractApiRequest {
  constructor(applicationUuid) {
    super();
    __publicField(this, "applicationUuid");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/application/:application_uuid");
    __publicField(this, "isPrivate", true);
    this.applicationUuid = applicationUuid;
  }
  getUrlParams() {
    return {
      application_uuid: this.applicationUuid
    };
  }
};
__name(_GetApplicationRequest, "GetApplicationRequest");
var GetApplicationRequest = _GetApplicationRequest;

// src/request/application/get-user-applications.request.ts
var _GetUserApplicationsRequest = class _GetUserApplicationsRequest extends AbstractApiRequest {
  constructor(status = void 0) {
    super();
    __publicField(this, "status");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/application/list");
    __publicField(this, "isPrivate", true);
    this.status = status;
  }
  getQueryParams() {
    return {
      status: this.status
    };
  }
};
__name(_GetUserApplicationsRequest, "GetUserApplicationsRequest");
var GetUserApplicationsRequest = _GetUserApplicationsRequest;

// src/request/files/get-file.request.ts
var _GetFileRequest = class _GetFileRequest extends AbstractApiRequest {
  constructor(url) {
    super();
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "isPrivate", true);
    __publicField(this, "url");
    this.url = url;
  }
};
__name(_GetFileRequest, "GetFileRequest");
var GetFileRequest = _GetFileRequest;

// src/request/deposit/get-similar-deposits.request.ts
var _GetSimilarDepositsRequest = class _GetSimilarDepositsRequest extends AbstractApiRequest {
  constructor(productIndex, language, isTest = false, offset = 0) {
    super();
    __publicField(this, "productIndex");
    __publicField(this, "language");
    __publicField(this, "isTest");
    __publicField(this, "offset");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/deposits/similar/:productIndex");
    this.productIndex = productIndex, this.language = language, this.isTest = isTest, this.offset = offset;
  }
  getUrlParams() {
    return {
      productIndex: this.productIndex
    };
  }
  getQueryParams() {
    return {
      language: this.language,
      is_test: this.isTest,
      offset: this.offset
    };
  }
};
__name(_GetSimilarDepositsRequest, "GetSimilarDepositsRequest");
var GetSimilarDepositsRequest = _GetSimilarDepositsRequest;

// src/request/cms/post-question-open-deposit.ts
var _PostQuestionOpenDepositRequest = class _PostQuestionOpenDepositRequest extends AbstractApiRequest {
  constructor(dto) {
    super();
    __publicField(this, "dto");
    __publicField(this, "method", ApiRequestMethod.POST);
    __publicField(this, "url", "/cms/api/question-opening-deposits");
    this.dto = dto;
  }
  getBody() {
    return this.dto;
  }
};
__name(_PostQuestionOpenDepositRequest, "PostQuestionOpenDepositRequest");
var PostQuestionOpenDepositRequest = _PostQuestionOpenDepositRequest;

// src/request/public/country/get-current-country.request.ts
var _GetCurrentCountryRequest = class _GetCurrentCountryRequest extends AbstractApiRequest {
  constructor() {
    super(...arguments);
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "clientOnly", true);
  }
  get url() {
    return `/api/public/country/current`;
  }
};
__name(_GetCurrentCountryRequest, "GetCurrentCountryRequest");
var GetCurrentCountryRequest = _GetCurrentCountryRequest;

// src/request/public/bank/get-banks-list.request.ts
var _GetBanksListRequest = class _GetBanksListRequest extends AbstractApiRequest {
  constructor(language, parameters) {
    super();
    __publicField(this, "language");
    __publicField(this, "parameters");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/public/bank/:languageCode2/list");
    this.language = language, this.parameters = parameters;
  }
  getUrlParams() {
    return {
      languageCode2: this.language
    };
  }
  getQueryParams() {
    return this.parameters;
  }
};
__name(_GetBanksListRequest, "GetBanksListRequest");
var GetBanksListRequest = _GetBanksListRequest;

// src/request/user/deposit/get-user-deposits-report.request.ts
var _GetUserDepositsReportRequest = class _GetUserDepositsReportRequest extends AbstractApiRequest {
  constructor() {
    super();
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/user/deposit/report");
    __publicField(this, "isPrivate", true);
  }
};
__name(_GetUserDepositsReportRequest, "GetUserDepositsReportRequest");
var GetUserDepositsReportRequest = _GetUserDepositsReportRequest;

// src/request/user/deposit/get-user-deposits-list.request.ts
var _GetUserDepositsListRequest = class _GetUserDepositsListRequest extends AbstractApiRequest {
  constructor(page = 1, status = void 0) {
    super();
    __publicField(this, "page");
    __publicField(this, "status");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/user/deposit/list");
    __publicField(this, "isPrivate", true);
    this.page = page, this.status = status;
  }
  getQueryParams() {
    return {
      page: this.page,
      status: this.status
    };
  }
};
__name(_GetUserDepositsListRequest, "GetUserDepositsListRequest");
var GetUserDepositsListRequest = _GetUserDepositsListRequest;

// src/request/user/product/get-user-product-availability.request.ts
var _GetUserProductAvailabilityRequest = class _GetUserProductAvailabilityRequest extends AbstractApiRequest {
  constructor(productIndex) {
    super();
    __publicField(this, "productIndex");
    __publicField(this, "method", ApiRequestMethod.GET);
    __publicField(this, "url", "/api/user/product/availability/:productIndex");
    __publicField(this, "isPrivate", true);
    this.productIndex = productIndex;
  }
  getUrlParams() {
    return {
      productIndex: this.productIndex
    };
  }
};
__name(_GetUserProductAvailabilityRequest, "GetUserProductAvailabilityRequest");
var GetUserProductAvailabilityRequest = _GetUserProductAvailabilityRequest;

// src/type/request/get-deposits-request.dto.ts
import { IsOptional, IsNotEmpty, IsArray, ArrayNotEmpty, IsInt, IsString, Length } from "class-validator";
import { Transform } from "class-transformer";
function _ts_decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate, "_ts_decorate");
function _ts_metadata(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata, "_ts_metadata");
var _GetDepositsQueryDto = class _GetDepositsQueryDto {
  constructor() {
    // @IsNumberString()
    __publicField(this, "offset", 0);
    __publicField(this, "language");
    __publicField(this, "country", []);
    __publicField(this, "currency", []);
    // Deposit type
    __publicField(this, "type", []);
    __publicField(this, "terms", []);
    __publicField(this, "is_partner");
    __publicField(this, "product_type", [
      "fixed term deposit"
    ]);
    __publicField(this, "bank_name");
    __publicField(this, "exclude");
    __publicField(this, "is_test", false);
  }
};
__name(_GetDepositsQueryDto, "GetDepositsQueryDto");
var GetDepositsQueryDto = _GetDepositsQueryDto;
_ts_decorate([
  IsOptional(),
  _ts_metadata("design:type", Number)
], GetDepositsQueryDto.prototype, "offset", void 0);
_ts_decorate([
  IsOptional(),
  IsNotEmpty(),
  IsString(),
  Length(2, 2),
  _ts_metadata("design:type", String)
], GetDepositsQueryDto.prototype, "language", void 0);
_ts_decorate([
  IsArray(),
  IsOptional(),
  IsString({
    each: true
  }),
  _ts_metadata("design:type", Array)
], GetDepositsQueryDto.prototype, "country", void 0);
_ts_decorate([
  IsArray(),
  IsOptional(),
  IsString({
    each: true
  }),
  Length(3, 3, {
    each: true
  }),
  _ts_metadata("design:type", Array)
], GetDepositsQueryDto.prototype, "currency", void 0);
_ts_decorate([
  IsArray(),
  IsOptional(),
  IsString({
    each: true
  }),
  _ts_metadata("design:type", Array)
], GetDepositsQueryDto.prototype, "type", void 0);
_ts_decorate([
  IsArray(),
  IsOptional(),
  IsInt({
    each: true
  }),
  Transform(({ value }) => value.map((item) => parseInt(item))),
  _ts_metadata("design:type", Array)
], GetDepositsQueryDto.prototype, "terms", void 0);
_ts_decorate([
  IsOptional(),
  Transform(({ value }) => value === "true"),
  _ts_metadata("design:type", Boolean)
], GetDepositsQueryDto.prototype, "is_partner", void 0);
_ts_decorate([
  IsArray(),
  ArrayNotEmpty(),
  IsOptional(),
  IsString({
    each: true
  }),
  _ts_metadata("design:type", Array)
], GetDepositsQueryDto.prototype, "product_type", void 0);
_ts_decorate([
  IsOptional(),
  IsNotEmpty(),
  _ts_metadata("design:type", String)
], GetDepositsQueryDto.prototype, "bank_name", void 0);
_ts_decorate([
  IsOptional(),
  IsNotEmpty(),
  _ts_metadata("design:type", Object)
], GetDepositsQueryDto.prototype, "exclude", void 0);
_ts_decorate([
  IsOptional(),
  Transform(({ value }) => value === "true"),
  _ts_metadata("design:type", Boolean)
], GetDepositsQueryDto.prototype, "is_test", void 0);

// src/type/request/auth/login.dto.ts
import { IsNumber, IsOptional as IsOptional2, IsString as IsString2, IsUrl, MaxLength, MinLength } from "class-validator";
function _ts_decorate2(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate2, "_ts_decorate");
function _ts_metadata2(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata2, "_ts_metadata");
var _LoginDTO = class _LoginDTO {
  constructor() {
    __publicField(this, "language");
    __publicField(this, "referral");
    __publicField(this, "productRequest");
    __publicField(this, "analyticsData");
    __publicField(this, "subscriptions");
    __publicField(this, "fallback_uri");
  }
};
__name(_LoginDTO, "LoginDTO");
var LoginDTO = _LoginDTO;
_ts_decorate2([
  IsString2(),
  MaxLength(2),
  MinLength(2),
  _ts_metadata2("design:type", String)
], LoginDTO.prototype, "language", void 0);
_ts_decorate2([
  IsOptional2(),
  IsString2(),
  _ts_metadata2("design:type", String)
], LoginDTO.prototype, "referral", void 0);
_ts_decorate2([
  IsNumber(),
  IsOptional2(),
  _ts_metadata2("design:type", Number)
], LoginDTO.prototype, "productRequest", void 0);
_ts_decorate2([
  IsOptional2(),
  _ts_metadata2("design:type", typeof AnalyticsData === "undefined" ? Object : AnalyticsData)
], LoginDTO.prototype, "analyticsData", void 0);
_ts_decorate2([
  IsOptional2(),
  _ts_metadata2("design:type", Array)
], LoginDTO.prototype, "subscriptions", void 0);
_ts_decorate2([
  IsOptional2(),
  IsUrl({
    require_host: false
  }),
  _ts_metadata2("design:type", String)
], LoginDTO.prototype, "fallback_uri", void 0);

// src/type/request/user/profile-attributes.dto.ts
import { IsObject } from "class-validator";
function _ts_decorate3(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate3, "_ts_decorate");
function _ts_metadata3(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata3, "_ts_metadata");
var AttributeTypesNames = /* @__PURE__ */ function(AttributeTypesNames2) {
  AttributeTypesNames2["FirstName"] = "first_name";
  AttributeTypesNames2["LastName"] = "last_name";
  AttributeTypesNames2["CitizenshipCountry"] = "citizenship_country";
  AttributeTypesNames2["ResidenceCountry"] = "residence_country";
  AttributeTypesNames2["Birthday"] = "birthday";
  AttributeTypesNames2["Gender"] = "gender";
  AttributeTypesNames2["Address"] = "address";
  AttributeTypesNames2["City"] = "city";
  AttributeTypesNames2["Region"] = "region";
  AttributeTypesNames2["ZipCode"] = "zip_code";
  AttributeTypesNames2["PhoneNumber"] = "phone_number";
  AttributeTypesNames2["IsPEP"] = "is_pep";
  AttributeTypesNames2["SourceOfFunds"] = "source_of_funds";
  AttributeTypesNames2["SourceOfFundsExtra"] = "source_of_funds_extra";
  AttributeTypesNames2["SourceOfWealth"] = "source_of_wealth";
  AttributeTypesNames2["SourceOfWealthExtra"] = "source_of_wealth_extra";
  AttributeTypesNames2["ApproximateWealthValue"] = "approximate_wealth_value";
  AttributeTypesNames2["ApproximateAnnualIncomeValue"] = "approximate_annual_income_value";
  AttributeTypesNames2["ReferencedAccount"] = "referenced_account";
  AttributeTypesNames2["EmploymentStatus"] = "employment_status";
  AttributeTypesNames2["Profession"] = "profession";
  AttributeTypesNames2["MaritalStatus"] = "marital_status";
  AttributeTypesNames2["TinNumber"] = "tin_number";
  AttributeTypesNames2["IsUsTaxResident"] = "is_us_tax_resident";
  AttributeTypesNames2["CountryOfBirth"] = "country_of_birth";
  AttributeTypesNames2["AdditionalDepositsAvailable"] = "additional_deposits_available";
  AttributeTypesNames2["AvailableCountries"] = "available_countries";
  AttributeTypesNames2["Comment"] = "comment";
  AttributeTypesNames2["EarlyPartialWithdrawals"] = "early_partial_withdrawals";
  AttributeTypesNames2["EarlyTermination"] = "early_termination";
  AttributeTypesNames2["AnnualFee"] = "annual_fee";
  AttributeTypesNames2["Cashback"] = "cashback";
  AttributeTypesNames2["SourceUrl"] = "source_url";
  AttributeTypesNames2["DocumentFile"] = "document_file";
  AttributeTypesNames2["PhoneNumbers"] = "phone_numbers";
  AttributeTypesNames2["SingleBankAccountForDepositsIBAN"] = "single_bank_account_for_deposits_iban";
  AttributeTypesNames2["SingleBankAccountForDepositsBIC"] = "single_bank_account_for_deposits_bic";
  AttributeTypesNames2["ActionAtMaturity"] = "action_at_maturity";
  AttributeTypesNames2["IdentityVerificationReport"] = "identity_verification_report";
  AttributeTypesNames2["IdDocuments"] = "id_documents";
  AttributeTypesNames2["Selfie"] = "selfie";
  AttributeTypesNames2["ProofOfAddress"] = "proof_of_address";
  return AttributeTypesNames2;
}({});
var _ProfileAttributesDto = class _ProfileAttributesDto {
  constructor() {
    __publicField(this, "attributes");
  }
};
__name(_ProfileAttributesDto, "ProfileAttributesDto");
var ProfileAttributesDto = _ProfileAttributesDto;
_ts_decorate3([
  IsObject(),
  _ts_metadata3("design:type", Object)
], ProfileAttributesDto.prototype, "attributes", void 0);

// src/type/request/application/post-application-confirm-request.dto.ts
import { IsBoolean, IsNumber as IsNumber2, IsObject as IsObject2, IsUUID, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
function _ts_decorate4(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate4, "_ts_decorate");
function _ts_metadata4(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata4, "_ts_metadata");
var _a;
var SignedConsentDto = (_a = class {
  constructor() {
    __publicField(this, "uuid");
    __publicField(this, "accepted");
  }
}, __name(_a, "SignedConsentDto"), _a);
_ts_decorate4([
  IsUUID(),
  _ts_metadata4("design:type", String)
], SignedConsentDto.prototype, "uuid", void 0);
_ts_decorate4([
  IsBoolean(),
  _ts_metadata4("design:type", Boolean)
], SignedConsentDto.prototype, "accepted", void 0);
var _a2;
var ConfirmActionDto = (_a2 = class {
  constructor() {
    __publicField(this, "consents");
    __publicField(this, "verifications");
  }
}, __name(_a2, "ConfirmActionDto"), _a2);
_ts_decorate4([
  ValidateNested(),
  Type(() => SignedConsentDto),
  _ts_metadata4("design:type", Array)
], ConfirmActionDto.prototype, "consents", void 0);
_ts_decorate4([
  ValidateNested(),
  Type(() => ConfirmVerificationDto),
  _ts_metadata4("design:type", Array)
], ConfirmActionDto.prototype, "verifications", void 0);
var _a3;
var ConfirmVerificationDto = (_a3 = class {
  constructor() {
    __publicField(this, "uuid");
    __publicField(this, "payload");
  }
}, __name(_a3, "ConfirmVerificationDto"), _a3);
_ts_decorate4([
  IsUUID(),
  _ts_metadata4("design:type", String)
], ConfirmVerificationDto.prototype, "uuid", void 0);
_ts_decorate4([
  IsObject2(),
  _ts_metadata4("design:type", Object)
], ConfirmVerificationDto.prototype, "payload", void 0);
var _PostApplicationConfirmRequestDto = class _PostApplicationConfirmRequestDto {
  constructor() {
    __publicField(this, "amount");
    __publicField(this, "confirm");
  }
};
__name(_PostApplicationConfirmRequestDto, "PostApplicationConfirmRequestDto");
var PostApplicationConfirmRequestDto = _PostApplicationConfirmRequestDto;
_ts_decorate4([
  IsNumber2(),
  _ts_metadata4("design:type", Number)
], PostApplicationConfirmRequestDto.prototype, "amount", void 0);
_ts_decorate4([
  ValidateNested(),
  Type(() => ConfirmActionDto),
  _ts_metadata4("design:type", typeof ConfirmActionDto === "undefined" ? Object : ConfirmActionDto)
], PostApplicationConfirmRequestDto.prototype, "confirm", void 0);

// src/type/request/application/post-application-apply-request.dto.ts
import { IsNumber as IsNumber3, IsString as IsString3, Length as Length2 } from "class-validator";
import { Transform as Transform2 } from "class-transformer";
function _ts_decorate5(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate5, "_ts_decorate");
function _ts_metadata5(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata5, "_ts_metadata");
var _PostApplicationApplyRequestDto = class _PostApplicationApplyRequestDto {
  constructor() {
    __publicField(this, "product_index");
    __publicField(this, "language");
  }
};
__name(_PostApplicationApplyRequestDto, "PostApplicationApplyRequestDto");
var PostApplicationApplyRequestDto = _PostApplicationApplyRequestDto;
_ts_decorate5([
  IsNumber3(),
  _ts_metadata5("design:type", Number)
], PostApplicationApplyRequestDto.prototype, "product_index", void 0);
_ts_decorate5([
  IsString3(),
  Length2(2, 2),
  Transform2(({ value }) => value.toUpperCase()),
  _ts_metadata5("design:type", String)
], PostApplicationApplyRequestDto.prototype, "language", void 0);

// src/type/request/public/bank/get-bank-request.dto.ts
import { IsBoolean as IsBoolean2, IsOptional as IsOptional3, IsString as IsString4, IsUUID as IsUUID2, Length as Length3 } from "class-validator";
import { Transform as Transform3 } from "class-transformer";
function _ts_decorate6(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate6, "_ts_decorate");
function _ts_metadata6(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata6, "_ts_metadata");
var _GetBankRequestDto = class _GetBankRequestDto {
  constructor() {
    __publicField(this, "index");
    __publicField(this, "uuid");
    __publicField(this, "slug");
    __publicField(this, "is_test");
  }
};
__name(_GetBankRequestDto, "GetBankRequestDto");
var GetBankRequestDto = _GetBankRequestDto;
_ts_decorate6([
  IsOptional3(),
  IsString4(),
  Length3(1, 12),
  _ts_metadata6("design:type", String)
], GetBankRequestDto.prototype, "index", void 0);
_ts_decorate6([
  IsOptional3(),
  IsUUID2(),
  _ts_metadata6("design:type", String)
], GetBankRequestDto.prototype, "uuid", void 0);
_ts_decorate6([
  IsOptional3(),
  IsString4(),
  _ts_metadata6("design:type", String)
], GetBankRequestDto.prototype, "slug", void 0);
_ts_decorate6([
  IsOptional3(),
  IsBoolean2(),
  Transform3(({ value }) => value === "true" ? true : value === "false" ? false : value),
  _ts_metadata6("design:type", Boolean)
], GetBankRequestDto.prototype, "is_test", void 0);

// src/type/response/application/application-response.dto.ts
var _ApplicationResponseDto = class _ApplicationResponseDto {
  constructor() {
    __publicField(this, "application");
  }
};
__name(_ApplicationResponseDto, "ApplicationResponseDto");
var ApplicationResponseDto = _ApplicationResponseDto;
var _ConfirmActionsResponseDto = class _ConfirmActionsResponseDto {
  constructor() {
    __publicField(this, "consents");
    __publicField(this, "verifications");
  }
};
__name(_ConfirmActionsResponseDto, "ConfirmActionsResponseDto");
var ConfirmActionsResponseDto = _ConfirmActionsResponseDto;

// src/type/response/public/country/currentCountry.dto.ts
var _CurrentCountryDto = class _CurrentCountryDto {
  constructor() {
    __publicField(this, "country");
  }
};
__name(_CurrentCountryDto, "CurrentCountryDto");
var CurrentCountryDto = _CurrentCountryDto;

// src/type/response/entity/bank/bank--full.dto.ts
var _BankFullDto = class _BankFullDto {
  constructor() {
    __publicField(this, "uuid");
    __publicField(this, "index");
    __publicField(this, "name");
    __publicField(this, "country");
    __publicField(this, "comment");
    __publicField(this, "phone", []);
    __publicField(this, "bic");
    __publicField(this, "client_rating");
    __publicField(this, "rating");
    __publicField(this, "address");
    __publicField(this, "web_site");
    __publicField(this, "trustpilot");
  }
};
__name(_BankFullDto, "BankFullDto");
var BankFullDto = _BankFullDto;

// ../../backend/app/src/shared/domain/dto/list-entities-response.dto.ts
var _ListEntitiesResponseDto = class _ListEntitiesResponseDto {
  constructor() {
    __publicField(this, "meta");
    __publicField(this, "data");
  }
};
__name(_ListEntitiesResponseDto, "ListEntitiesResponseDto");
var ListEntitiesResponseDto = _ListEntitiesResponseDto;

// src/type/response/entity/bank/bank--list.dto.ts
var _BankListDto = class _BankListDto {
  constructor() {
    __publicField(this, "uuid");
    __publicField(this, "name");
    __publicField(this, "index");
    __publicField(this, "slug");
    __publicField(this, "country");
    __publicField(this, "client_rating");
  }
};
__name(_BankListDto, "BankListDto");
var BankListDto = _BankListDto;
var _BankListResponseDto = class _BankListResponseDto extends ListEntitiesResponseDto {
};
__name(_BankListResponseDto, "BankListResponseDto");
var BankListResponseDto = _BankListResponseDto;

// src/type/response/entity/deposit/deposit-entity--full.dto.ts
var _DepositEntityFullDto = class _DepositEntityFullDto {
  constructor() {
    __publicField(this, "uuid");
    __publicField(this, "currency");
    __publicField(this, "date");
    __publicField(this, "expirationDate");
    // TODO: Add ApplicationEntityListDto
    __publicField(this, "application");
    __publicField(this, "amount");
    __publicField(this, "interest_amount");
  }
};
__name(_DepositEntityFullDto, "DepositEntityFullDto");
var DepositEntityFullDto = _DepositEntityFullDto;

// src/type/response/entity/deposit/deposit-entity--list.dto.ts
var _DepositEntityListDto = class _DepositEntityListDto {
  constructor() {
    __publicField(this, "uuid");
    __publicField(this, "currency");
    // TODO: Add ApplicationEntityListDto
    __publicField(this, "application");
    __publicField(this, "date");
    __publicField(this, "expiration_date");
    __publicField(this, "amount");
    __publicField(this, "interest_amount");
    __publicField(this, "bank");
  }
};
__name(_DepositEntityListDto, "DepositEntityListDto");
var DepositEntityListDto = _DepositEntityListDto;

// ../../backend/app/src/shared/domain/dto/single-entity-response.dto.ts
var _SingleEntityResponseDto = class _SingleEntityResponseDto {
  constructor() {
    __publicField(this, "meta");
    __publicField(this, "data");
  }
};
__name(_SingleEntityResponseDto, "SingleEntityResponseDto");
var SingleEntityResponseDto = _SingleEntityResponseDto;

// ../../backend/app/src/user/domain/model/user-subscriptions.dto.ts
import { IsBoolean as IsBoolean3, IsEnum, ValidateNested as ValidateNested2 } from "class-validator";
import { Exclude, Expose, Type as Type2 } from "class-transformer";

// ../../backend/app/src/user/domain/model/user-environment.dto.ts
var _UserEnvironmentDto = class _UserEnvironmentDto {
  constructor() {
    __publicField(this, "ipAddress");
    __publicField(this, "userAgent");
    __publicField(this, "ipCountry");
  }
};
__name(_UserEnvironmentDto, "UserEnvironmentDto");
var UserEnvironmentDto = _UserEnvironmentDto;

// ../../backend/app/src/user/domain/model/user-subscriptions.dto.ts
function _ts_decorate7(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate7, "_ts_decorate");
function _ts_metadata7(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata7, "_ts_metadata");
var UserSubscriptionTypesEnum = /* @__PURE__ */ function(UserSubscriptionTypesEnum2) {
  UserSubscriptionTypesEnum2["MonthlyNewsletter"] = "monthly-newsletter";
  UserSubscriptionTypesEnum2["ServiceNews"] = "service-news";
  UserSubscriptionTypesEnum2["DepositApplicationStatusChange"] = "deposit-application-status-change";
  UserSubscriptionTypesEnum2["OtherEvents"] = "other-events";
  return UserSubscriptionTypesEnum2;
}({});
var UserSubscriptionChannelsEnum = /* @__PURE__ */ function(UserSubscriptionChannelsEnum2) {
  UserSubscriptionChannelsEnum2["Email"] = "email";
  return UserSubscriptionChannelsEnum2;
}({});
var _UserSubscriptionDto = class _UserSubscriptionDto {
  constructor() {
    __publicField(this, "type");
    __publicField(this, "channel");
    __publicField(this, "is_active", false);
  }
};
__name(_UserSubscriptionDto, "UserSubscriptionDto");
var UserSubscriptionDto = _UserSubscriptionDto;
_ts_decorate7([
  Expose({
    name: "type"
  }),
  IsEnum(UserSubscriptionTypesEnum),
  _ts_metadata7("design:type", String)
], UserSubscriptionDto.prototype, "type", void 0);
_ts_decorate7([
  Expose({
    name: "channel"
  }),
  IsEnum(UserSubscriptionChannelsEnum),
  _ts_metadata7("design:type", String)
], UserSubscriptionDto.prototype, "channel", void 0);
_ts_decorate7([
  Expose({
    name: "is_active"
  }),
  IsBoolean3(),
  _ts_metadata7("design:type", Boolean)
], UserSubscriptionDto.prototype, "is_active", void 0);
var _UserSubscriptionsCollectionDto = class _UserSubscriptionsCollectionDto {
  constructor(data) {
    __publicField(this, "subscriptions");
    __publicField(this, "confirmed_at");
    __publicField(this, "user_tracking");
    if (data) {
      Object.assign(this, data);
    }
  }
};
__name(_UserSubscriptionsCollectionDto, "UserSubscriptionsCollectionDto");
var UserSubscriptionsCollectionDto = _UserSubscriptionsCollectionDto;
_ts_decorate7([
  Expose({
    name: "subscriptions"
  }),
  ValidateNested2({
    each: true
  }),
  Type2(() => UserSubscriptionDto),
  _ts_metadata7("design:type", Array)
], UserSubscriptionsCollectionDto.prototype, "subscriptions", void 0);
_ts_decorate7([
  Exclude(),
  _ts_metadata7("design:type", typeof Date === "undefined" ? Object : Date)
], UserSubscriptionsCollectionDto.prototype, "confirmed_at", void 0);
_ts_decorate7([
  Exclude(),
  _ts_metadata7("design:type", typeof UserEnvironmentDto === "undefined" ? Object : UserEnvironmentDto)
], UserSubscriptionsCollectionDto.prototype, "user_tracking", void 0);

// ../../backend/app/src/application/domain/model/application-status.enum.ts
var ApplicationStatusEnum = /* @__PURE__ */ function(ApplicationStatusEnum2) {
  ApplicationStatusEnum2["DRAFT"] = "DRAFT";
  ApplicationStatusEnum2["NEW"] = "NEW";
  ApplicationStatusEnum2["PENDING"] = "PENDING";
  ApplicationStatusEnum2["READY_TO_SEND"] = "READY_TO_SEND";
  ApplicationStatusEnum2["SENT"] = "SENT";
  ApplicationStatusEnum2["RECEIVED"] = "RECEIVED";
  ApplicationStatusEnum2["APPROVED"] = "APPROVED";
  ApplicationStatusEnum2["WAIT_MONEY_TRANSFER"] = "WAIT_MONEY_TRANSFER";
  ApplicationStatusEnum2["MONEY_TRANSFERRED"] = "MONEY_TRANSFERRED";
  ApplicationStatusEnum2["EXPIRED"] = "EXPIRED";
  ApplicationStatusEnum2["REJECTED"] = "REJECTED";
  ApplicationStatusEnum2["CANCELLED"] = "CANCELLED";
  return ApplicationStatusEnum2;
}({});

// ../../backend/app/src/deposit/domain/model/deposit-statuses.enum.ts
var DepositStatusesEnum = /* @__PURE__ */ function(DepositStatusesEnum2) {
  DepositStatusesEnum2["OPENED"] = "ACTIVE";
  DepositStatusesEnum2["REPAID"] = "REPAID";
  DepositStatusesEnum2["RENOVATED"] = "RENOVATED";
  DepositStatusesEnum2["TERMINATED"] = "TERMINATED";
  DepositStatusesEnum2["EXPIRED"] = "EXPIRED";
  return DepositStatusesEnum2;
}({});

// ../../backend/app/src/user/domain/model/user-attributes/source-of-funds-user-attribute.enum.ts
var SourceOfFundsUserAttributeEnum = /* @__PURE__ */ function(SourceOfFundsUserAttributeEnum2) {
  SourceOfFundsUserAttributeEnum2["EmploymentOrIndividualBusinessIncome"] = "employment_or_individual_business_income";
  SourceOfFundsUserAttributeEnum2["BusinessProfitOrDividends"] = "business_profit_or_dividends";
  SourceOfFundsUserAttributeEnum2["SaleOfInvestmentsOrLiquidationOfPortfolio"] = "sale_of_investments_or_liquidation_of_portfolio";
  SourceOfFundsUserAttributeEnum2["PropertySale"] = "property_sale";
  SourceOfFundsUserAttributeEnum2["IoanAndFinancing"] = "loan_and_financing";
  SourceOfFundsUserAttributeEnum2["Inheritance"] = "inheritance";
  SourceOfFundsUserAttributeEnum2["Gift"] = "gift";
  SourceOfFundsUserAttributeEnum2["Other"] = "other";
  return SourceOfFundsUserAttributeEnum2;
}({});

// ../../backend/app/src/user/domain/model/user-attributes/is-pep-user-attribute.enum.ts
var IsPepUserAttributeEnum = /* @__PURE__ */ function(IsPepUserAttributeEnum2) {
  IsPepUserAttributeEnum2["No"] = "no";
  IsPepUserAttributeEnum2["Yes"] = "yes";
  IsPepUserAttributeEnum2["FamilyMember"] = "family_member";
  IsPepUserAttributeEnum2["CloseAssociate"] = "close_associate";
  return IsPepUserAttributeEnum2;
}({});

// ../../backend/app/src/application/domain/model/consent-types.enum.ts
var ConsentTypesEnum = /* @__PURE__ */ function(ConsentTypesEnum2) {
  ConsentTypesEnum2["TermsAndConditions"] = "terms-and-conditions";
  ConsentTypesEnum2["PrivacyPolicy"] = "privacy-policy";
  ConsentTypesEnum2["TermsOfUse"] = "terms-of-use";
  ConsentTypesEnum2["DataProtectionPolicy"] = "data-protection-policy";
  ConsentTypesEnum2["DataProcessingAgreement"] = "data-processing-agreement";
  ConsentTypesEnum2["CookiePolicy"] = "cookie-policy";
  ConsentTypesEnum2["Contract"] = "contract";
  ConsentTypesEnum2["ProductInformationSheet"] = "product-information-sheet";
  return ConsentTypesEnum2;
}({});

// ../../backend/app/src/compliance/domain/model/compliance-verification-status.enum.ts
var ComplianceVerificationStatusEnum = /* @__PURE__ */ function(ComplianceVerificationStatusEnum2) {
  ComplianceVerificationStatusEnum2["INIT"] = "init";
  ComplianceVerificationStatusEnum2["PENDING"] = "pending";
  ComplianceVerificationStatusEnum2["APPROVED"] = "approved";
  ComplianceVerificationStatusEnum2["REJECTED"] = "rejected";
  return ComplianceVerificationStatusEnum2;
}({});

// ../../backend/app/src/user/domain/model/user-attributes/user-attributes.enum.ts
var EmploymentStatusUserAttributeEnum = /* @__PURE__ */ function(EmploymentStatusUserAttributeEnum2) {
  EmploymentStatusUserAttributeEnum2["EMPLOYED"] = "employed";
  EmploymentStatusUserAttributeEnum2["SELF_EMPLOYED"] = "self_employed";
  EmploymentStatusUserAttributeEnum2["UNEMPLOYED"] = "unemployed";
  EmploymentStatusUserAttributeEnum2["STUDENT"] = "student";
  EmploymentStatusUserAttributeEnum2["RETIREMENT"] = "retirement";
  return EmploymentStatusUserAttributeEnum2;
}({});

// ../../backend/app/src/user/domain/model/user-attributes/user-gender.enum.ts
var UserGender = /* @__PURE__ */ function(UserGender2) {
  UserGender2["MALE"] = "male";
  UserGender2["FEMALE"] = "female";
  return UserGender2;
}({});
export {
  ApiService,
  ApplicationResponseDto,
  ApplicationStatusEnum,
  AttributeTypesNames,
  BankFullDto,
  BankListDto,
  BankListResponseDto,
  ComplianceVerificationStatusEnum,
  ConfirmActionsResponseDto,
  ConsentTypesEnum,
  CurrentCountryDto,
  DepositEntityFullDto,
  DepositEntityListDto,
  DepositStatusesEnum,
  EmploymentStatusUserAttributeEnum,
  GetApplicationRequest,
  GetBankRequestDto,
  GetBanksListRequest,
  GetBlogItemRequest,
  GetBlogItemsQueryDto,
  GetBlogItemsRequest,
  GetComplianceVerificationRequest,
  GetComplianceVerificationStatusRequest,
  GetCountriesRequest,
  GetCurrentCountryRequest,
  GetDepositRequest,
  GetDepositsQueryDto,
  GetDepositsRequest,
  GetDepositsStatisticsRequest,
  GetFileRequest,
  GetFilteredBlogItemsRequest,
  GetFooterPagesRequest,
  GetSimilarDepositsRequest,
  GetSlugLandingPageRequest,
  GetSlugPageRequest,
  GetUserApplicationsRequest,
  GetUserDepositsListRequest,
  GetUserDepositsReportRequest,
  GetUserProductAvailabilityRequest,
  GetUserProfileAttributesRequest,
  GetUserProfileRequest,
  IsPepUserAttributeEnum,
  ListEntitiesResponseDto,
  LoginDTO,
  PostApplicationApplyRequest,
  PostApplicationApplyRequestDto,
  PostApplicationConfirmRequest,
  PostApplicationConfirmRequestDto,
  PostComplianceVerificationActionRequest,
  PostComplianceVerificationVerifyRequest,
  PostLoginRequest,
  PostLoginRequestError,
  PostQuestionOpenDepositRequest,
  PostVerifyRequest,
  ProfileAttributesDto,
  PutUserProfileAttributesRequest,
  PutUserProfileRequest,
  SingleEntityResponseDto,
  SourceOfFundsUserAttributeEnum,
  UserGender,
  UserSubscriptionChannelsEnum,
  UserSubscriptionTypesEnum
};
//# sourceMappingURL=index.mjs.map